module.exports = __webpack_public_path__ + "static/img/pc-pickup-recruit.7c2aebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pc-pickup-recruit.png
// module id = Lq8K
// module chunks = 1